import React, { useEffect, useRef, useState } from 'react'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import CatalogGoodContainer from '@mobileComponents/catalog/CatalogGoodContainer/CatalogGoodContainer'
import { ScrollBody } from 'src/shared/ui/mobile/scroll-body'
import { useStore } from 'effector-react'
import { $shipment } from '@entities/shipment/model'
import dynamic from 'next/dynamic'
import { useRemoveSuggestion } from 'src/features/suggestions/hooks/use-remove-suggestion'
import { ShipmentStateMobile } from 'src/features/shipment-state/ui'

const FilterSortBlockGoods = dynamic(() => import('src/features/filter-goods').then((x) => x.FilterSortBlockGoods), {
    ssr: false
})

const MobileSearchPage = () => {
    const shipment = useStore($shipment)
    const [heightHeader, setHeightHeader] = useState(84)
    const blockHeaderRef = useRef(null)

    useEffect(() => {
        if (blockHeaderRef?.current?.getBoundingClientRect().height !== heightHeader)
            setHeightHeader(blockHeaderRef?.current?.getBoundingClientRect().height)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blockHeaderRef?.current?.clientHeight, shipment.shipAddressId])
    useRemoveSuggestion()

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const scrollRef = useRef(null)

    // noinspection JSValidateTypes
    return (
        <React.Fragment>
            <MobileHeader
                blockRef={blockHeaderRef}
                searchInput={{
                    isShowed: true
                }}>
                Поиск
            </MobileHeader>
            <ScrollBody scrollRef={scrollRef}>
                <ShipmentStateMobile />
                <FilterSortBlockGoods targetRef={scrollRef} />
                {/*{!isGoodsAvailable && <S.EmptyBlock>По вашему запросу ничего не найдено</S.EmptyBlock>}*/}
                <CatalogGoodContainer />
            </ScrollBody>
        </React.Fragment>
    )
}

export default MobileSearchPage
